<style lang="less" scoped>
  .buy-info-area {
    width: 100%;
    background: white;
    border-radius: 8px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.24);

    .buy-info {
      border-bottom: 1px solid #d9dde8;
      padding: 24px 16px;

      .buy-info-row {
        margin-bottom: 24px;

        &:last-child {
          margin-bottom: 0;
        }
      }

      .buy-info-title {
        margin-bottom: 16px;
        display: block;
      }
      .buy-info-input {
        margin-bottom: 16px;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    .buy-result {
      padding: 24px 16px;

      .cost {
        display: block;
      }
      .present {
        color: #8492a6;
        margin-bottom: 15px;
      }
      .buy-continue-btn {
        width: 100%;
      }
    }
  }
  .delivery-select-box {
    width: 100%;
  }
  @media screen and (max-width: 560px) {
    .buy-info {
      padding: 0 !important;
      border: none !important;
    }
    .buy-result {
      display: none;
    }
  }
</style>

<template lang="pug">
  .buy-info-area
    .buy-info
      div.buy-info-row
        strong.buy-info-title 받는 사람
        el-input.buy-info-input(placeholder="이름" v-model="orders.name")
        el-input.buy-info-input(placeholder="전화번호" v-model="orders.phoneNumber")
        el-input.buy-info-input(placeholder="주소" v-model="orders.address")
      div.buy-info-row
        strong.buy-info-title 결제방법
        el-radio(v-model="orders.paymentMethod" label="card") 신용카드
        el-radio(v-model="orders.paymentMethod" label="trans") 계좌이체
      div.buy-info-row
        strong.buy-info-title 배송방법
        el-select.delivery-select-box(
          v-model="orders.delivery",
          style="{ width: '100%' }")
          el-option(
            v-for="delivery in deliveries",
            v-bind="delivery",
            :label="delivery.label",
            :value="delivery.value",)
    .buy-result
      strong.cost 총 {{totalPrice.toLocaleString()}}원
      .present
        span {{orderName}}
      el-button.buy-continue-btn(type="success" native-type="submit") 결제하기
</template>

<script>
import happytree from '@/happytree';
export default {
  props: ['orders', 'totalPrice'],
  computed: {
    firstPrescriptionName() {
      const name = this.orders.prescriptions.length > 0 ? this.orders.prescriptions[0].name : null;
      return name;
    },
    otherCount() {
      const count = this.orders.prescriptions.length - 1;
      return count > 0 ? count : false;
    },
    orderName() {
      let result = this.firstPrescriptionName;
      if (this.otherCount) {
        result = result.concat(` 외 ${this.otherCount}건`);
      }
      return result;
    },
  },
  data() {
    return {
      deliveries: [{
        label: '일반 배송 (4,000원)',
        value: happytree.delivery.basic,
      }, {
        label: '수도권 당일 배송 (5,000원)',
        value: happytree.delivery.oneday,
      }],
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/sender_form.vue